export default "__VITE_ASSET__BRGkLeCb__"